const SubmitionStatus = {
	pending: 0,
	accepted: 1,
	rejected: 2,
	submitted: 3,
	stopped: 4,
	inactive: 5,
};
export default SubmitionStatus;
